<template>
  <Popover popper-class="popover-medium" placement="bottom-end" v-model="comment">
    <div class="popover-primary">
      <div class="popover-primary-header">
        <h3>COMMENTS</h3>
        <span class="remove-icon" @click="comment=false">
          <svgicon name="cancel" width="10" height="10" :original="true" />
        </span>
      </div>
      <div class="popover-primary-body">
        <div>
          <Comment />
          <Comment />
          <Comment />
        </div>
        <textarea rows="1"></textarea>
      </div>
    </div>
    <div slot="reference">
      <svgicon name="document" width="10" height="10" :original="true" /> COMMENTS
    </div>
  </Popover>
</template>
<script>
import Comment from './comment';

export default {
  components: { Comment },
  data() {
    return {
      comment: false,
    };
  },
};
</script>
